/**
 * This file contains utility functions about date and time
 */

/**
 * Get ISO format date string from Date object
 * @param {Date} date Date to format
 * @returns {string} ISO date with format "yyyy-mm-dd"
 */
export function stringifyISODate(date) {
    const day = date.getDate();
    const dd = day < 10 ? `0${day}` : day.toString();
    const month = date.getMonth() + 1;
    const mm = month < 10 ? `0${month}` : month.toString();
    return `${date.getFullYear()}-${mm}-${dd}`;
}

/**
 * Get Date object from ISO format date string
 * @param {string} dateStr ISO date string with format "yyyy-mm-dd"
 * @returns {Date} Date object with parsed date
 */
export function parseISODate(dateStr) {
    const dateParts = dateStr.split('-');
    return new Date(dateParts[0], parseInt(dateParts[1], 10) - 1, dateParts[2]);
}
